/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
import React, { ReactNode } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { Popup } from 'semantic-ui-react'
import isEmpty from 'lodash/isEmpty'

import { LKDate } from 'loankeeper-common/helpers/Date'
import { translate as mainTranslator } from 'loankeeper-common/helpers'
import { loadFont } from 'loankeeper-common/helpers/styles'

import container from './container'
import ServerTimeTicker from '../shared/ServerTimeTicker'
import OfficialRates from './OfficialRates'
import StatusBarNoficiation from './StatusBarNotification'
import translator from './translator'
import { StatusBarProps, StatusBarState } from './statusbar.types'
import { CCYCommercialRates } from '../OrderAdd/ConvertOnAccountInCash/ConvertOnAccountInCash.types'

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 27px;
  background: ${(props) => (props.locked ? 'black' : 'var(--color-statusbar-background)')};
  border-top: 1px solid var(--color-statusbar-border);
  z-index: 101;

  .navbar-container {
    margin: 0;
    padding: 0;
    text-align: center;
  }

  .operation-day {
    color: lightpink;
    font-weight: 700;
  }

  .item {
    display: inline-block;
    line-height: 27px;
    font-size: 13px;
    padding: 0 10px;
    color: var(--color-statusbar-text) !important;
    line-height: 27px !important;
    ${(props) => loadFont(props.theme.statusBarFont)};
  }
`

const formatRate = (rateStr: string | number) => {
  const num = Number(rateStr)
  return !isNaN(num) ? num.toFixed(4) : 1 // eslint-disable-line no-restricted-globals
}

const dispalyUserInfo = (username: string, ServerName: string, DisplayToken: string, Database: string) => `
  ${username}, 
  ${ServerName}, 
  ${Database},
  ${DisplayToken}`

class StatusBar extends React.Component<StatusBarProps, StatusBarState> {
  state = {
    isOpenUserInfo: false,
  }
  timeout: NodeJS.Timeout
  arrRates: CCYCommercialRates[]

  getNotification(compareWith: CCYCommercialRates[], masterList: CCYCommercialRates[]) {
    this.arrRates = this.props.commercialRates

    return masterList.reduce((accumulator: ReactNode[], commNode, index) => {
      const matchNode = compareWith.find(
        (stateNode) => stateNode.CCY === commNode.CCY && stateNode.CCY2 === commNode.CCY2,
      )

      if (!matchNode || matchNode.RateBuy !== commNode.RateBuy || matchNode.RateSell !== commNode.RateSell) {
        const notificationLabel = mainTranslator('LKMESSAGE-ERR_WARN_COMM_RATE_CHANGED')
        const notificationMessage = `${notificationLabel} ${commNode.CCY} - ${commNode.CCY2}`

        accumulator.push(
          //@ts-ignore
          <StatusBarNoficiation key={index} notificationMessage={notificationMessage} class="navbar-container" />,
        )
      }
      return accumulator
    }, [])
  }

  handleOpen = () => {
    if (!this.state.isOpenUserInfo) {
      this.setState({ isOpenUserInfo: true })
      this.timeout = setTimeout(() => {
        this.setState({ isOpenUserInfo: false })
      }, 2000) // 2 sec
    }
  }

  handleClick = () => {
    clearTimeout(this.timeout)
    this.setState({ isOpenUserInfo: true })
    this.timeout = setTimeout(() => {
      this.setState({ isOpenUserInfo: false })
    }, 5000) // 5 sec
  }

  renderNotification(stateRates: CCYCommercialRates[], commercialRates: CCYCommercialRates[]) {
    if (stateRates.length <= commercialRates.length) {
      return this.getNotification(stateRates, commercialRates)
    }

    return this.getNotification(commercialRates, stateRates)
  }

  render() {
    const {
      operationalDay,
      nodeTitle,
      currentDate,
      username,

      foreignCCY,
      foreignCCY2,
      localCCY,
      officialRate,
      officialRate2,
      commercialRate,
      commercialRate2,
    } = this.props

    const { isOpenUserInfo } = this.state

    const target = <div onClick={this.handleClick}>{username}</div>

    // set initial values to state
    if (!this.arrRates || this.arrRates.length === 0) {
      this.arrRates = this.props.commercialRates
    }
    // end --  set initial values to state

    const shouldRenderNotification =
      this.arrRates && this.props.commercialRates && this.arrRates.length > 0 && this.props.commercialRates.length > 0

    const operationDateMessage = `${translator('mnu_other_operating_day')} ${operationalDay}`

    return (
      <>
        <div style={{ paddingLeft: '5px' }}>
          {shouldRenderNotification && this.renderNotification(this.arrRates, this.props.commercialRates)}
        </div>
        <Wrapper locked={!!this.props.locked}>
          <div className="navbar-container">
            {!!this.props.locked && <div className="item">Close day operation / Fail</div>}
            <div className="item">
              {LKDate.from(operationalDay).instance < LKDate.from(moment(currentDate).format('DD.MM.YYYY')).instance ? (
                <div className="operation-day">{operationDateMessage}</div>
              ) : (
                operationDateMessage
              )}
            </div>
            <div className="item">
              <OfficialRates
                localCCY={localCCY}
                items={[
                  { currency: foreignCCY, rate: officialRate.OffRate },
                  { currency: foreignCCY2, rate: officialRate2.OffRate },
                ]}
              />
            </div>
            <div className="item">
              {`1 ${foreignCCY} = ` +
                (!isEmpty(commercialRate)
                  ? `${formatRate(commercialRate.RateBuy)}/${formatRate(commercialRate.RateSell)} ${localCCY}`
                  : mainTranslator('LKMESSAGE-MSG_ERROR')) +
                ' | '}
              {`1 ${foreignCCY2} = ` +
                (!isEmpty(commercialRate2)
                  ? `${formatRate(commercialRate2.RateBuy)}/${formatRate(commercialRate2.RateSell)} ${localCCY}`
                  : mainTranslator('LKMESSAGE-MSG_ERROR'))}
            </div>
            <div className="item">{nodeTitle}</div>
            <div className="item">
              <Popup
                content={dispalyUserInfo(
                  username,
                  this.props.session.ServerName,
                  this.props.session.DisplayToken,
                  this.props.session.Database,
                )}
                trigger={target}
                position="top center"
                open={isOpenUserInfo}
                onOpen={this.handleOpen}
              />
            </div>

            <div className="item">
              {`${translator('lbl_sys_date')} `}
              {currentDate && <ServerTimeTicker currentDate={currentDate} />}
            </div>
          </div>
        </Wrapper>
      </>
    )
  }
}

export default container(StatusBar)
